import React from 'react'

const Social = () => {
  return (
   <div className="home__social">
    <a href="https://www.linkedin.com/in/sebastian-cruz-r/" className="home__social-icon" target="_blank" rel="noopener noreferrer" aria-label="Sebastian Cruz on LinkedIn">
        <i className="uil uil-linkedin"></i>
    </a>

    <a href="https://github.com/SCR08" className="home__social-icon" target="_blank" rel="noopener noreferrer" aria-label="Sebastian Cruz on GitHub">
        <i className="uil uil-github"></i>
    </a>

    <a href="https://www.behance.net/sebastiancruz18" className="home__social-icon" target="_blank" rel="noopener noreferrer" aria-label="Sebastian Cruz on Behance">
        <i className="uil uil-behance"></i>
    </a>
   </div>
  )
}

export default Social
